import { borderRadius, breakpoints, ButtonGroup } from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { ChartAreaWrapper } from '~/components/chart-area-wrapper/ChartAreaWrapper';
import { ChartLoading } from '~/modules/simple-chart/components/chart-loading/ChartLoading';

import { PriceChartArea } from '../price-chart-area/PriceChartArea';

export const StyledChartAreaWrapper = styled(ChartAreaWrapper)`
  position: relative;
  height: 240px;

  @media ${breakpoints['max-lg']} {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: var(--background-default);
  }
`;

export const StyledPriceChartArea = styled(PriceChartArea)`
  position: relative;
`;

export const StyledButtonGroup = styled(ButtonGroup)<{
  $activeIndex: number;
}>`
  margin: 12px 0;
  width: fit-content;
  ${borderRadius.r3};
  border-width: 0px;
  background-color: var(--surface-default);

  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${({ $activeIndex }) =>
      css`
        &:nth-child(${$activeIndex + 1}) {
          ${borderRadius.r2};
          border: 1px solid var(--text-primary);
          background-color: unset;
        }
      `}
  }
`;

export const StyledChartLoading = styled(ChartLoading)`
  margin-top: 12px;
  min-height: unset;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;
